module.exports = __webpack_public_path__ + "img/planting-hands.42a681dd.png";